import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {syncStoreWithUrl} from 'modules/meta/slice'
import {useRouter} from 'next/router'
import {getSearchFromPath} from 'utils/urlParams'

export const useSyncStoreWithUrl = () => {
  const dispatch = useDispatch()
  const {asPath} = useRouter()

  useEffect(() => {
    dispatch(syncStoreWithUrl({queryString: getSearchFromPath(asPath)}))
  }, [dispatch, asPath])
}
